import { useEphattaQuery } from "../../.."
import { useAdvertInboxService } from "./useAdvertInboxService"

export const useAdvertInbox = (inboxId: number, suspense=false) => {
    const service = useAdvertInboxService()
    return useEphattaQuery(["Adverts.Inbox", inboxId], () => service.getById(inboxId), {enabled: !!inboxId, suspense})
} 